import { useHistory } from 'react-router-dom';
import { FieldValues, SubmitHandler, useFormContext } from 'react-hook-form';
import { PlacementsCreateFormState } from 'modules/placements/types';
import { useCreatePlacement } from 'modules/placements/hooks/useCreatePlacement';
import { BUTTON_SIZES, PrimaryButton, SecondaryButton } from 'ui/button';
import { SecondaryPageHeader } from 'ui/pageHeader';
import { transformPlacementFormToInput } from 'modules/placements/utils';
import { ButtonGroup, Description } from './styles';

const CONTENT = {
  breadcrumbLabel: 'All Placements',
  cancelButtonLabel: 'Cancel',
  createButtonLabel: 'Create',
  pageHeaderPlaceholder: 'New placement',
};

export const MANAGE_PLACEMENTS_PATH = '/settings/placements';

const breadcrumb = {
  href: MANAGE_PLACEMENTS_PATH,
  content: CONTENT.breadcrumbLabel,
};

const PageSubsection = () => (
  <Description>
    Use these settings to describe this placement, and to configure its preview in Iterable to
    resemble the way your apps and websites display this placement to end users.
  </Description>
);

const PageActions = () => {
  const createPlacement = useCreatePlacement();
  const { handleSubmit, trigger } = useFormContext();

  const onSubmit: SubmitHandler<FieldValues> = (formValues: FieldValues) => {
    trigger().then((isValid) => {
      if (isValid) {
        createPlacement({
          variables: {
            placement: transformPlacementFormToInput(formValues as PlacementsCreateFormState),
          },
        });
      }
    });
  };

  const history = useHistory();

  return (
    <ButtonGroup>
      <SecondaryButton
        data-test="page-header-cancel-button"
        onClick={() => history.push(MANAGE_PLACEMENTS_PATH)}
        size={BUTTON_SIZES.LARGE}
      >
        {CONTENT.cancelButtonLabel}
      </SecondaryButton>
      <PrimaryButton
        data-test="page-header-create-button"
        onClick={handleSubmit(onSubmit)}
        size={BUTTON_SIZES.LARGE}
      >
        {CONTENT.createButtonLabel}
      </PrimaryButton>
    </ButtonGroup>
  );
};

export const PageHeader = ({ name }: { name: string }) => {
  return (
    <SecondaryPageHeader
      documentTitle={`${name || CONTENT.pageHeaderPlaceholder} | Embedded Placements`}
      data-test="page-header"
      breadcrumb={breadcrumb}
      pageSubSection={<PageSubsection />}
      pageActions={<PageActions />}
    >
      {name || CONTENT.pageHeaderPlaceholder}
    </SecondaryPageHeader>
  );
};
